function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

import { getMixpanel } from '@domain-group/fe-helper';

var trackMixpanel = function trackMixpanel(eventName, data, getMixpanelBaseProps) {
  if (typeof getMixpanelBaseProps !== 'function') {
    // consumers opt in to tracking by passing their base props func. if not provided, do not track at all.
    return;
  }

  var mixpanel = getMixpanel();

  if (mixpanel) {
    try {
      mixpanel.track(eventName, _objectSpread(_objectSpread({}, getMixpanelBaseProps()), data));
    } catch (err) {// mixpanel.track will fail if mixpanel.init() has not been called by the root component
      // so, ignore for now
    }
  } else if (process.env.NODE_ENV !== 'production') {
    // eslint-disable-next-line no-console
    console.log("DUMMY MIXPANEL TRACK CALL:\n".concat(eventName), _objectSpread(_objectSpread({}, getMixpanelBaseProps()), data));
  }
};

export var viewedMessage = function viewedMessage(_ref, getMixpanelBaseProps) {
  var messageHeadline = _ref.messageHeadline;
  trackMixpanel('Viewed Message Component', {
    messageHeadline: messageHeadline
  }, getMixpanelBaseProps);
};
export var actionedMessage = function actionedMessage(_ref2, getMixpanelBaseProps) {
  var messageHeadline = _ref2.messageHeadline,
      actionTaken = _ref2.actionTaken,
      actionUrl = _ref2.actionUrl;
  trackMixpanel('Actioned Message Component', {
    messageHeadline: messageHeadline,
    actionTaken: actionTaken,
    actionUrl: actionUrl
  }, getMixpanelBaseProps);
};